import React from "react";
import Heading from "../ui/Heading";
import Slider from "react-slick";
import { Container, Image } from "react-bootstrap";


import solitairImg from '../Assets/img/shopbystyle/solitaire.png';
import ChannelImg from '../Assets/img/shopbystyle/channel-set.png';
import threeStoneImg from '../Assets/img/shopbystyle/sidestone.png';
import vintageImg from '../Assets/img/shopbystyle/vintage.png';
import paveImg from '../Assets/img/shopbystyle/pave.png';
import haloImg from '../Assets/img/shopbystyle/halo.png';
import othersImg from '../Assets/img/shopbystyle/eternity.png';
import bypassImg from '../Assets/img/shopbystyle/curved.png';
import stackableImg from '../Assets/img/shopbystyle/stackable.png';
import aniversaryImg from '../Assets/img/shopbystyle/aniversary.png';

import RightIcon from '../Assets/img/right-icon.svg'
import LeftIcon from '../Assets/img/left-icon.svg'
import { Link } from "react-router-dom/cjs/react-router-dom";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { Je_welryspelling } from "../../../../Helpers/request";

const ShopRingByStyle = () => {

  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: <img src={LeftIcon} alt="left-icon" />,
    nextArrow: <img src={RightIcon} alt="right-icon" />,
    className: "center",
    centerMode: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const sliderItems = [
    {
      id: 1,
      imgsrc: ChannelImg,
      styleName: "Channel Settings",
      URL: "/ringsettings/style=Channel Set"

    },
    // {
    //   id: 2,
    //   imgsrc: aniversaryImg,
    //   styleName: "Anniversary Settings",
    //   url: "/jewelry/wedding-rings/style=Anniversary"
    // },
    {
      id: 3,
      imgsrc: threeStoneImg,
      styleName: "3 Stone Settings",
      url: "ringsettings/style=Three stone"
    },
    {
      id: 4,
      imgsrc: solitairImg,
      styleName: "Solitaire",
      url: "/ringsettings/style=Solitaire"
    },
    {
      id: 5,
      imgsrc: paveImg,
      styleName: "Pave Settings",
      url: "/ringsettings/style=Pave"
    },
    {
      id: 6,
      imgsrc: haloImg,
      styleName: "Halo Settings",
      url: "/ringsettings/style=Halo"
    },
    // {
    //   id: 7,
    //   imgsrc: othersImg,
    //   styleName: "Other settings",
    //   url: "/gemstones/color=Other"
    // },
    {
      id: 8,
      imgsrc: bypassImg,
      styleName: "Bypass Settings",
      url: "ringsettings/style=Bypass"
    },
    // {
    //   id: 9,
    //   imgsrc: stackableImg,
    //   styleName: "Stackable Settings",
    //   url: "/wedding-rings/style=Stackable"
    // },
    {
      id: 10,
      imgsrc: vintageImg,
      styleName: "Vintage Settings",
      url: "/ringsettings/style=Vintage"
    }
  ];


  return (
    <section className="shop-ring-by-style section-space">
      <Container fluid className="showcase-container">
        <Heading className="text-center">
          <h2>Shop By Style</h2>
          <p>Find Your Signature Look</p>
        </Heading>

        <Slider {...settings}>
          {sliderItems?.map((item, index) =>
            <div key={index} className='shop_Style_item'>
              <Link to={item.url}>
                <Image src={item?.imgsrc} alt={item?.styleName} />
              </Link>
              <Link to={item.url} className="text">{item?.styleName}</Link>
            </div>
          )
          }

          {/* <div className="item">
            <Link to="/ringsettings/style=Solitaire">
              <Image src={Solitaire} alt="Solitaire" />
            </Link>
            <Link to="/ringsettings/style=Solitaire">Solitaire</Link>
          </div>
          <div className="item">
            <Link to="/ringsettings/style=Three%20stone">
              <Image src={ThreeStone} alt="ThreeStone" />
            </Link>
            <Link to="/ringsettings/style=Three%20stone">Three Stone</Link>
          </div>
          <div className="item">
            <Link to="/ringsettings/style=Single Row">
              <Image src={SingleRow} alt="SingleRow" />
            </Link>
            <Link to="/ringsettings/style=Single Row">Single Row</Link>
          </div>
          <div className="item">
            <Link to="/ringsettings/style=Multirow">
              <Image src={MultiRow} alt="Multirow" />
            </Link>
            <Link to="/ringsettings/style=Multirow">Multirow</Link>
          </div>
          <div className="item">
            <Link to="/ringsettings/style=Bypass">
              <Image src={ByPass} alt="Bypass" />
            </Link>
            <Link to="/ringsettings/style=Bypass">Bypass</Link>
          </div>
          <div className="item">
            <Link to="/ringsettings/style=Solitaire">
              <Image src={Solitaire} alt="Solitaire" />
            </Link>
            <Link to="/ringsettings/style=Solitaire">Solitaire</Link>
          </div> */}
        </Slider>
      </Container>
    </section>
  );
};

export default ShopRingByStyle;
